import { AuthenticatedHttpClient } from "@/lib/axios";
import { PermissionValues } from "@/pages/role/constants";
import { Role } from "@/types/premission.types";

export class RoleService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  // -------------------- Premissions --------------------

  async getMyPermissions(): Promise<PermissionValues[]> {
    const response = await this.http.get("/roles/my/permissions");
    return response as unknown as PermissionValues[];
  }

  async getMemberPermissions(memberId: string): Promise<PermissionValues[]> {
    const response = await this.http.get(
      `/roles/member/${memberId}/permissions`
    );
    return response as unknown as PermissionValues[];
  }

  async hasPermission(permission: PermissionValues): Promise<boolean> {
    const response = await this.http.get(`/permissions/check/${permission}`);
    return response as unknown as boolean;
  }

  // -------------------- Roles --------------------

  async getRoles(): Promise<Role[]> {
    const response = await this.http.get("/roles");
    return response as unknown as Role[];
  }

  async getRole(id: string): Promise<Role> {
    const response = await this.http.get(`/roles/${id}`);
    return response as unknown as Role;
  }

  async createRole(
    role: Pick<Role, "name" | "description" | "permissions">
  ): Promise<Role> {
    const response = await this.http.post("/roles", role);
    return response as unknown as Role;
  }

  async updateRole(id: string, role: Partial<Role>): Promise<Role> {
    const response = await this.http.put(`/roles/${id}`, role);
    return response as unknown as Role;
  }

  async deleteRole(id: string): Promise<void> {
    await this.http.delete(`/roles/${id}`);
  }

  async assignRoleToMember(memberId: string, roleId: string): Promise<void> {
    await this.http.put(`/roles/assign/${memberId}/role/${roleId}`);
  }

  // -------------------- Bulk Actions --------------------

  async bulkDeleteRoles(ids: string[]): Promise<void> {
    await this.http.post("/roles/bulk-delete", { ids });
  }
}
